import { normalizeServiceRole, toMarketplaceServiceRoleId } from "./npidClient";
import { resolveCaregiverServiceRole } from "./isPhysioCaregiver";

/** True when caregiver service role is nurse / nurses / RN. */
export function isNurseServiceRole(value) {
  return normalizeServiceRole(value) === "nurse";
}

export function isNurseFromProfile(source) {
  return isNurseServiceRole(resolveCaregiverServiceRole(source));
}

export { resolveCaregiverServiceRole, toMarketplaceServiceRoleId };
